/**
 * IRS Single Life Expectancy Table (Pub 590-B Appendix B, Table I) — the
 * post-2022 version, used for inherited-IRA beneficiary RMDs.
 *
 * Mechanics ("reduce by one"): the beneficiary looks up life expectancy ONCE,
 * at their age in the year AFTER the owner's death, then subtracts 1 for each
 * subsequent year.
 *
 * Five-year milestone values verified against the published table
 * (25→60.2, 30→55.3, 40→45.7, 50→36.2, 55→31.6, 60→27.1, 65→22.9, 70→18.8,
 * 75→14.8, 80→11.2, 85→8.1, 90→5.7). Intermediate tenths follow the published
 * table; spot-VERIFY against Pub 590-B before relying on a single-year edge.
 */
export const SINGLE_LIFE_TABLE: Record<number, number> = {
  20: 65.0, 21: 64.1, 22: 63.1, 23: 62.1, 24: 61.1,
  25: 60.2, 26: 59.2, 27: 58.2, 28: 57.3, 29: 56.3,
  30: 55.3, 31: 54.4, 32: 53.4, 33: 52.5, 34: 51.5,
  35: 50.5, 36: 49.6, 37: 48.6, 38: 47.7, 39: 46.7,
  40: 45.7, 41: 44.8, 42: 43.8, 43: 42.9, 44: 41.9,
  45: 41.0, 46: 40.0, 47: 39.0, 48: 38.1, 49: 37.1,
  50: 36.2, 51: 35.3, 52: 34.3, 53: 33.4, 54: 32.5,
  55: 31.6, 56: 30.6, 57: 29.8, 58: 28.9, 59: 28.0,
  60: 27.1, 61: 26.2, 62: 25.4, 63: 24.5, 64: 23.7,
  65: 22.9, 66: 22.0, 67: 21.2, 68: 20.4, 69: 19.6,
  70: 18.8, 71: 18.0, 72: 17.2, 73: 16.4, 74: 15.6,
  75: 14.8, 76: 14.1, 77: 13.3, 78: 12.6, 79: 11.9,
  80: 11.2, 81: 10.5, 82: 9.9, 83: 9.3, 84: 8.7,
  85: 8.1, 86: 7.6, 87: 7.1, 88: 6.6, 89: 6.1,
  90: 5.7, 91: 5.3, 92: 4.9, 93: 4.6, 94: 4.3,
  95: 4.0, 96: 3.7, 97: 3.4, 98: 3.2, 99: 3.0,
  100: 2.8, 101: 2.6, 102: 2.5, 103: 2.3, 104: 2.2, 105: 2.1,
};

export function singleLifeExpectancy(age: number): number {
  if (age < 20) return SINGLE_LIFE_TABLE[20]! + (20 - age); // approximation below table floor
  if (age > 105) return SINGLE_LIFE_TABLE[105]!;
  return SINGLE_LIFE_TABLE[age] ?? SINGLE_LIFE_TABLE[105]!;
}
